module.exports = __webpack_public_path__ + "static/Electronics1-32905695d9c5d2c0f0ad100236b4970b.png";